// src/App.js
import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import Web3Provider from './providers/Web3Provider';
import { WalletProvider } from './context/WalletContext';
import { AuthSiweProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import { AddFundsProvider } from './components/credits/AddFunds';

import MainAppLayout from './components/MainAppLayout';

import './index.css';
import './App.css';

// /cam is a standalone phone-camera route. Importing it eagerly here put
// livekit-client in the main bundle for every visitor, including one who
// only ever sees the landing page.
const CamPage = lazy(() => import('./pages/CamPage'));

function App() {
  return (
    <Web3Provider>
      <Router>
        <AuthSiweProvider>
          <WalletProvider>
            <ToastProvider>
              <AddFundsProvider>
              <Routes>
                {/* Public phone-camera route */}
                <Route
                  path="/cam"
                  element={
                    <Suspense fallback={null}>
                      <CamPage />
                    </Suspense>
                  }
                />

                {/* Everything else uses the normal app layout */}
                <Route
                  path="/*"
                  element={<MainAppLayout />}
                />
              </Routes>
              </AddFundsProvider>
            </ToastProvider>
          </WalletProvider>
        </AuthSiweProvider>
      </Router>
    </Web3Provider>
  );
}

export default App;